import React from 'react';

import AllocationModule from '../allocation/components/AllocationModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryAllocationModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.allocation', action: 'read' },
      ]}
    >
      <AllocationModule />
    </InventoryPermissionGuard>
  );
}